const errorCode: { [error_code: number]: string } = {
  1000: "Ocurrió un error, por favor contacte a reservas.",
  1001: "El código de seguridad de la tarjeta (CVV) debe ser de 3 o 4 dígitos, dependiendo del tipo de tarjeta.",
  1002: "Ocurrió un error, por favor contacte a reservas.",
  1003: "La operación no se pudo completar, por favor verifique que los datos del formulario estén llenados correctamente.",
  1004: "Un servicio necesario para el procesamiento de la transacción no se encuentra disponible.",
  1005: "Uno de los recursos requeridos no existe.",
  1006: "Ya existe una transacción con ese mismo número.",
  1007: "La transferencia de fondos entre una cuenta de banco o tarjeta no fue aceptada.",
  1008: "Una de las cuentas se encuentra desactivada.",
  1009: "La operación no se pudo completar, por favor verifique que los datos del formulario estén llenados correctamente.",
  1010: "Algo salió mal.",
  1011: "Recurso no disponible.",
  1012: "El monto de la transacción está fuera de los límites permitidos.",
  1013: "Lo sentimos, la operación no está permitida.",
  1014: "Ocurrió un error, por favor contacte a reservas.",
  1015: "Intente de nuevo. El servicio no está disponible.",
  1016: "El correo electrónico ya ha sido procesado.",
  1017: "Ocurrió un problema, por favor intente de nuevo más tarde.",
  1018: "Número de intentos de cargo excedido. Por favor, inténtelo más tarde.",
  1020: "Los decimales son inválidos para esta moneda.",
  1023: "Ocurrió un error, por favor contacte al área de reservas.",
  1024: "El monto de la transacción excede el límite permitido.",
  1025: "Ocurrió un error en las transacciones. Intente contactar a soporte.",
  2004: "El número de verificación de la tarjeta no es correcto.",
  2005: "La fecha de expiración de la tarjeta es anterior a la fecha actual.",
  2006: "El código de seguridad de la tarjeta (CVV) no fue proporcionado.",
  2007: "Ocurrió un error. Intente de nuevo más tarde.",
  2008: "La tarjeta no es válida para pago con puntos.",
  2009: "El código de seguridad de la tarjeta (CVV) es inválido.",
  2010: "Ocurrió un error. Intente de nuevo más tarde.",
  2011: "La de tarjeta no está soportado.",
  3001: "La tarjeta fue rechazada por el banco.",
  3002: "La tarjeta ha expirado.",
  3003: "La tarjeta no tiene fondos suficientes.",
  3004: "La tarjeta no ha sido reconocida, inténtelo más tarde.",
  3005: "La tarjeta ha sido rechazada.",
  3006: "La operación no está permitida para este cliente o esta transacción.",
  3009: "La tarjeta fue reportada como perdida.",
  3010: "El banco ha restringido la tarjeta.",
  3011: "El banco ha solicitado que la tarjeta sea retenida. Contacte al banco.",
  3012: "Se requiere solicitar al banco autorización para realizar este pago.",
  3201: "Comercio no autorizado para procesar pago a meses sin intereses.",
  3203: "Promoción no válida para este tipo de tarjetas.",
  3204: "El monto de la transacción es menor al mínimo permitido para la promoción.",
  3205: "Promoción no permitida.",
};

const errorCodeCards: { [code: number]: string } = {
  2004: "El número de verificación de la tarjeta es inválido.",
  2005: "La fecha de expiración de la tarjeta es anterior a la fecha actual.",
  2006: "El código de seguridad de la tarjeta (CVV2) no fue proporcionado.",
  2007: "Ocurrió un error. Intente de nuevo más tarde.",
  2008: "La tarjeta no es válida para pago con puntos.",
  2009: "El código de seguridad de la tarjeta (CVV) es inválido.",
  2010: "Ocurrió un error. Intente de nuevo más tarde.",
  2011: "La de tarjeta no está soportado.",
  3001: "La tarjeta fue rechazada por el banco.",
  3002: "La tarjeta ha expirado.",
  3003: "La tarjeta no tiene fondos suficientes.",
  3004: "La tarjeta no ha sido reconocida, inténtelo más tarde.",
  3005: "La tarjeta ha sido rechazada.",
  3006: "La operación no está permitida para este cliente o esta transacción.",
  3009: "La tarjeta fue reportada como perdida.",
  3010: "El banco ha restringido la tarjeta.",
  3011: "El banco ha solicitado que la tarjeta sea retenida. Contacte al banco.",
  3012: "Se requiere solicitar al banco autorización para realizar este pago.",
  3201: "Comercio no autorizado para procesar pago a meses sin intereses.",
  3203: "Promoción no válida para este tipo de tarjetas.",
  3204: "El monto de la transacción es menor al mínimo permitido para la promoción.",
  3205: "Promoción no permitida.",
};

export const useErrorCodeOpenPay = () => {
  const getErrorCode = (error_code: number) => {
    return errorCode[error_code] ?? undefined;
  };

  const getErrorCodeCards = (code: number) => {
    return errorCodeCards[code] ?? undefined;
  };

  return {
    getErrorCode,
    getErrorCodeCards,
  };
};
